// define used error code
export enum ErrorCode {
  NotResponse = -1,

  // status
  Success = 1,
  Failed = 2,
  PicError = 3,

  // user
  UserNotExist = 5100,
  UserLoginInvalid = 5101,
  UserAccountDisable = 5102,

  // materials
  MaterialAlreadyExist = 5201,
  BoardDoesNotHaveMaterial = 5203,
  CreateDataExist = 5204,
  DesignExceedLimit = 5307,

  // member
  MemberPaletteMainExist = 6000,

  ServerError = 10000
}

// define used error message (lang key)
export const ErrorMessage: { [key: number]: string } = {
  [ErrorCode.Failed]: "failed",
  [ErrorCode.PicError]: "image upload failed",

  [ErrorCode.UserNotExist]: "user not exist",
  [ErrorCode.UserLoginInvalid]: "user login invalid",
  [ErrorCode.UserAccountDisable]: "user account disable",

  [ErrorCode.MaterialAlreadyExist]: "this material already exists",
  [ErrorCode.BoardDoesNotHaveMaterial]: "this board does not have this material",
  [ErrorCode.CreateDataExist]: "already exists.",
  [ErrorCode.DesignExceedLimit]: "You can save up to 30 designs. Please delete the design and try again.",

  [ErrorCode.MemberPaletteMainExist]: "main palette is exist",

  [ErrorCode.ServerError]: "server error",
};
